import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { NavigateFunction } from 'react-router-dom';
import { decodeJwtPayload, isJwtPayloadExpired } from './jwt';

export const getAccessToken = () => {
  return Cookies.get('ca_token');
};

export function convertStringToDate(dateString: string | null) {
  if (dateString === null || undefined) {
    return new Date();
  }
  const [day, month, year] = dateString.split('/').map(Number); // Split and convert to numbers
  return new Date(year, month - 1, day); // Month is zero-based
}

export const stringToSha256Hash = (inputString: string) => {
  const hashedText = CryptoJS.SHA256(inputString);
  const hexHash = hashedText.toString(CryptoJS.enc.Hex);
  return hexHash;
};

export const isTokenExpired = (token: string) => {
  if (!token) return true;
  return isJwtPayloadExpired(decodeJwtPayload(token));
};

/**
 * Decodes the JWT returned by verify-otp and extracts the lounge_id claim.
 * Returns the lounge_id string if present, null otherwise.
 *
 * This is the authoritative source for loungeId after login — the backend
 * embeds it in the signed token only when the loungeId was validated server-side.
 * Returning null (when lounge_id is absent) is the normal non-QR login case;
 * verify-otp.tsx routing falls through to /select-city when loungeId is null.
 */
export const getLoungeIdFromToken = (token: string): string | null => {
  const payload = decodeJwtPayload<{ lounge_id?: unknown }>(token);
  return typeof payload?.lounge_id === 'string' ? payload.lounge_id : null;
};

/**
 * Navigate to appropriate page based on city and loungeId.
 * Uses route-based navigation instead of query parameters.
 *
 * @param navigate - React Router navigate function
 * @param loungeId - Optional lounge ID to include in URL
 * @param city - Optional city to include in URL
 */
export const navigateToHomeWithLounge = (
  navigate: NavigateFunction,
  loungeId?: string | null,
  city?: string | null,
) => {
  if (loungeId) {
    navigate(`/booking/${loungeId}${city ? `?city=${city}` : ''}`);
  } else if (city) {
    navigate(`/select-lounge/${city}`);
  } else {
    navigate('/');
  }
};
